import React from 'react';
import '../styles/Features.css';

const Features: React.FC = () => {
  const features = [
    {
      id: 'shielded-transactions',
      title: 'Shielded Transactions',
      description: 'We will revive shielded transactions (z-transactions) to enhance user privacy. This feature, disabled in KMD mainchain since February 15, 2019, will be reintroduced to KMDCL. We aim to make KMDCL one of the leading privacy coins, allowing users to create private transactions with z-addresses.',
      icon: 'shield'
    },
    {
      id: 'aur',
      title: '5% AUR (Active User Reward)',
      description: 'The original 5% AUR (Active User Reward), reduced in KMD as described in KIP-0001, will be restored in KMDCL. This change is in response to community feedback, ensuring users continue to benefit from the initial AUR design.',
      icon: 'trending-up'
    },
    {
      id: 'block-reward',
      title: '3 KMDCL Block Reward',
      description: 'We will revert the block reward reduction rules described in <a href="https://github.com/KomodoPlatform/kips/blob/main/kips/kip-0002.mediawiki" target="_blank" rel="noopener noreferrer">KIP-0002</a>. KMDCL will restore the 3 KMDCL block reward, maintaining the original incentive structure for miners.',
      icon: 'database'
    },
    {
      id: 'replay-protection',
      title: 'Replay Attack Protection',
      description: 'To protect users from accidentally losing funds, we will implement replay attack protection. This will make transactions from KMD invalid on the KMDCL chain and vice versa after the fork.',
      icon: 'shield'
    },
    {
      id: 'distribution',
      title: '1:1 Coin Distribution',
      description: 'At the time of the fork, every KMD holder will receive an equivalent amount of KMDCL coins in a 1:1 ratio.',
      icon: 'repeat'
    },
    {
      id: 'dex',
      title: 'Decentralized Exchange (DEX)',
      description: 'We plan to run a DEX based on Komodo technologies, allowing users to exchange KMD for KMDCL and vice versa at market prices. This will provide seamless and secure trading within the Komodo ecosystem.',
      icon: 'refresh-cw'
    }
  ];

  return (
    <section id="features" className="section features-section">
      <div className="container">
        <div className="section-header">
          <h2>Key Features of Komodo Classic</h2>
          <p>Our community-driven initiative is focused on reviving and enhancing these essential features</p>
        </div>
        
        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card aos-animate" data-aos="fade-up">
              <div className="feature-icon">
                <i data-feather={feature.icon}></i>
              </div>
              <h3>{feature.title}</h3>
              <p dangerouslySetInnerHTML={{ __html: feature.description }}></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
